// Acquisti — conferma eliminazione definitiva di un ordine (qualsiasi stato)
import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Trash2, Loader2 } from "lucide-react";
import { Button } from "../components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../components/ui/dialog";
import { P, STATUS, fail } from "./shared";

export function DeleteOrderDialog({ order, onClose, onDeleted }) {
  const [busy, setBusy] = useState(false);
  const remove = async () => {
    setBusy(true);
    try { await axios.delete(`${P}/orders/${order.id}`); toast.success(`Ordine ${order.order_number} eliminato`); onClose(); onDeleted(); } catch (e) { fail(e); setBusy(false); }
  };
  const warn = ["sent", "confirmed", "partial", "received"].includes(order.status);
  return <Dialog open onOpenChange={() => !busy && onClose()}><DialogContent className="acq-dialog max-w-md" data-testid="purchase-delete-dialog">
    <DialogHeader><DialogTitle>Eliminare l'ordine {order.order_number}?</DialogTitle><DialogDescription>{order.supplier?.business_name} · {STATUS[order.status]} · {order.items?.length || 0} articoli</DialogDescription></DialogHeader>
    <p className="text-sm">L'ordine sparisce da tutte le liste e non può essere ripristinato. Eventuali documenti allegati restano nell'archivio del fornitore.</p>
    {warn && <p className="text-sm text-red-700 font-medium" data-testid="purchase-delete-warning">Attenzione: questo ordine è già stato {STATUS[order.status].toLowerCase()} al fornitore. Se vuoi conservarne traccia, usa "Annulla ordine" invece di eliminarlo.</p>}
    <div className="flex flex-col sm:flex-row gap-2 sm:justify-end mt-2">
      <Button variant="outline" className="acq-touch" disabled={busy} onClick={onClose} data-testid="purchase-delete-cancel">Torna indietro</Button>
      <Button className="acq-touch bg-red-700 text-white hover:bg-red-800" disabled={busy} onClick={remove} data-testid="purchase-delete-confirm">{busy ? <Loader2 size={16} className="animate-spin mr-2" /> : <Trash2 size={16} className="mr-2" />}Elimina definitivamente</Button>
    </div>
  </DialogContent></Dialog>;
}
